<template>
  <v-dialog
    v-model="dialog"
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        v-on="on"
      >
        Create Rank
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Rank"
      text="Create Rank"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="value"
                v-validate="'min_value:1|max_value:255|required'"   
                :error-messages="errors.collect('value')"     
                type="number"           
                data-vv-name="value"          
                label="Rank"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="title"
                :error-messages="errors.collect('title')"
                data-vv-name="title"
                label="Title"
              />
            </v-col>
            <v-col cols="12">
              <helper-image-input  
                v-model="image" 
                v-validate="'required'"
                :max-size-in-mb="2"
                data-vv-name="image"
                field-name="image"
                accept-type=".svg"   
                extension="ext:svg"           
              >          
                <div 
                  slot="activator"
                  class="mb-2"
                >   
                  <v-btn                    
                    :disabled="progressing"
                    class="mx-2"    
                  >
                    Add Image
                  </v-btn>
                  <span> 
                    {{ image ? image.imageFile.name : 'No file chosen (.svg only)' }}
                  </span>
                </div>
              </helper-image-input>
              <span class="red--text text--lighten-1">{{ errors.first('image') }}</span>
            </v-col>
          </v-row>
        </v-container>
      </form> 
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      HelperImageInput: () => import('@/components/helper/ImageInput'),
    },
    inject: ['$validator'],
    data () {
      return {
        dialog: null,
        progressing: false,
        title: '',
        value: 0,
        image: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        
        this.resetForm()
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true

            this.image.formData.set('title', this.title)
            this.image.formData.set('value', this.value)
    
            this.$api.ranks().create(this.image.formData)
              .then((res) => {
                if (res.status >= 200 && res.status < 300) {
                  this.$emit('created', res.data)                
                  this.$snack({ message: 'Added new rank' })

                  this.dialog = false                
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      resetForm () {
        this.title = ''
        this.value = 0
        this.image = null

        this.$validator.reset()
      },
    },
  }
</script>
